import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  group_members_list_container: {
    marginTop: 20,
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
  },
  create_group_container: {
    minHeight: 180,
    width: '100%',
    position: 'relative',
  },
}));

export default useStyles;
